"use client";
import * as React from "react";
const SvgChatRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16.2 0H1.8C.81 0 0 .77 0 1.72v13.42c0 .76.97 1.15 1.54.6l2.06-1.97h12.6c.99 0 1.8-.78 1.8-1.72V1.72C18 .77 17.19 0 16.2 0" }));
export {
  SvgChatRound as default
};
